import { Navigate } from 'react-router-dom';
import { usePracticeSettingsItems } from '@features/organizations/hooks/usePracticeSettingsItems';
import { useOrganizationInfo } from '@features/user';
import { Alert } from '@mui/material';

/** Land on the first settings page this member can use, including delegated managers. */
export function PracticeIndexRedirect({
  scheduleDocumentation = false,
}: {
  scheduleDocumentation?: boolean;
}) {
  const organization = useOrganizationInfo();
  const items = usePracticeSettingsItems();
  const destination = scheduleDocumentation
    ? items.find(item => item.group === 'Scheduling' || item.group === 'Documentation')
    : items[0];
  if (!organization) return null;
  if (!destination)
    return (
      <Alert severity="info">
        You don&apos;t have permission to manage these practice settings.
      </Alert>
    );
  return <Navigate to={destination.path} replace />;
}
